<template lang="pug">
redesign-documents-list(
  v-if="documents.length"
  :documents="documents"
)
p(v-else) Отсутствуют прикрепленные документы
</template>

<script>
import RedesignDocumentsList from '@/components/user-redesign/RedesignDocumentsList.vue';

export default {
  name: 'DocumentsTab',

  components: { RedesignDocumentsList },

  props: {
    eventId: { type: [String, Number], required: true },
  },

  data() {
    return {
      documents: [],
    };
  },

  created() {
    this.loadQuestions();
  },

  methods: {
    loadQuestions() {
      this.$rHandler(this.$api.events.getPublicEventDocuments({
        'search[event_id]':this.eventId,
      }), (response) => {
        this.documents = response.data.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
